var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"width":"600px","title":"选择原料","visible":_vm.visible},on:{"ok":_vm.handleOk,"cancel":_vm.handleCancel}},[_c('a-table',{attrs:{"row-selection":{ selectedRowKeys: _vm.selectedRowKeys, onChange:_vm.onSelectChange},"pagination":_vm.pagination,"columns":_vm.materialSelectColumns,"data-source":_vm.materialList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }